import React from 'react'
import OpeProgress from '../app-templates/ope-progress-bar'
import DetailedContainer from './detailed/container'
import AdobeAnalytics from '../../utils/adobe-analytics'
import OrderStore from '../../stores/order-store'
import ProductList from './product-list/product-list'
import UploadProgressBar from '../app-selector/upload-progress-bar'
import createReactClass from 'create-react-class'


var Editor = createReactClass({
  componentDidMount: function() {
      var instance = this;

      if (Object.keys(OrderStore.getItems()).length === 0) {
          instance.setState({statusMessage: _('Empty session.')});
          window.location.hash = "";
      } else {
          AdobeAnalytics.setEditPhotosPage();

          //Scroll to top
          document.body.scrollTop = document.documentElement.scrollTop = 0;
      }
  },
  componentWillMount: function () {
    var items = OrderStore.getItems();

    //Remove all the upsale options from the items, otherwise there will be quite the mess
    for (var i = 0; i < items.length; i++) {
     items[i].resetUpsaleOptions();
    }
  },
  render: function() {
    return (
      <div>
        <UploadProgressBar />
        <OpeProgress progressActiveStates={[false, true, false]} />
        <ProductList />
      </div>
    );
  }
});

export default Editor;
